module.exports = __webpack_public_path__ + "static/media/smart-filter-bg-within-two-hour-loads.77b71449.svg";